import { animate, state, style, transition, trigger, useAnimation } from '@angular/animations';
import { reusable } from '@app/shared/animations/reusable.animation';

export const SpinnerContentAnimation = [
  trigger('animate', [transition('void => *', [useAnimation(reusable)])]),

  trigger('fadeInOut', [
    state(
      '0',
      style({
        opacity: 0,
        display: 'none',
      })
    ),
    state(
      '1',
      style({
        opacity: 1,
        display: 'block',
      })
    ),
    transition('0 => 1', animate('300ms')),
    transition('1 => 0', animate('300ms')),
  ]),
];
